exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NoInteractions___1FQiN {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.Header___26pfp {\n  font-size: var(--font-size-sans-large);\n}\n\n.Link___1QIRe {\n  color: var(--color-button);\n}\n", ""]);

// exports
exports.locals = {
	"NoInteractions": "NoInteractions___1FQiN",
	"Header": "Header___26pfp",
	"Link": "Link___1QIRe"
};